var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"picture-preview"},[_c('div',{staticClass:"preview-close",on:{"click":_vm.handleClose}},[_c('i')]),_c('div',{staticClass:"preview-container"},[_c('img',{attrs:{"src":_vm.src,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }